var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 115,
    viewBox: "0 0 154 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#b0bec5;}.a{fill-rule:evenodd;}.b,.d{fill:none;}.d{stroke:#b0bec5;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-466 -668)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17622 308.225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18101 377.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3064.9,1261h13.276a1.9,1.9,0,0,1,1.9,1.9v13.276a1.9,1.9,0,0,1-1.9,1.9H3064.9a1.9,1.9,0,0,1-1.9-1.9V1262.9A1.9,1.9,0,0,1,3064.9,1261Zm4.077,12.6a.945.945,0,0,0,1.337,0l7.188-7.2a.946.946,0,0,0-1.338-1.337l-6.524,6.524-2.731-2.731a.945.945,0,0,0-1.337,0,.951.951,0,0,0,0,1.337Z",
    transform: "translate(-3060.082 -1258.081)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18101 398.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3064.9,1261h13.276a1.9,1.9,0,0,1,1.9,1.9v13.276a1.9,1.9,0,0,1-1.9,1.9H3064.9a1.9,1.9,0,0,1-1.9-1.9V1262.9A1.9,1.9,0,0,1,3064.9,1261Zm4.077,12.6a.945.945,0,0,0,1.337,0l7.188-7.2a.946.946,0,0,0-1.338-1.337l-6.524,6.524-2.731-2.731a.945.945,0,0,0-1.337,0,.951.951,0,0,0,0,1.337Z",
    transform: "translate(-3060.082 -1258.081)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18106 419.775)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3112.9,1261h13.275a1.9,1.9,0,0,1,1.9,1.9v13.276a1.9,1.9,0,0,1-1.9,1.9H3112.9a1.9,1.9,0,0,1-1.9-1.9V1262.9A1.9,1.9,0,0,1,3112.9,1261Zm.948,15.172h11.38a.951.951,0,0,0,.948-.948v-11.379a.951.951,0,0,0-.948-.948h-11.38a.95.95,0,0,0-.948.948v11.379A.951.951,0,0,0,3113.844,1276.172Z",
    transform: "translate(-3108.081 -1258.081)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18159.441 404.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.774,418.4H80.752a5.31,5.31,0,0,0,5.306-5.31v-.025l.029-14.758a5.334,5.334,0,0,0-5.334-5.334H33.772a5.348,5.348,0,0,0-5.334,5.334v14.758A5.351,5.351,0,0,0,33.774,418.4Zm0-17.427a2.667,2.667,0,0,1,2.667-2.667H78.085a2.667,2.667,0,0,1,2.667,2.667v8.711H33.772Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(30.733 8.956)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(37.083 8.956)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(43.322 8.956)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18159.441 435.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.774,418.4H80.752a5.31,5.31,0,0,0,5.306-5.31v-.025l.029-14.758a5.334,5.334,0,0,0-5.334-5.334H33.772a5.348,5.348,0,0,0-5.334,5.334v14.758A5.351,5.351,0,0,0,33.774,418.4Zm0-17.427a2.667,2.667,0,0,1,2.667-2.667H78.085a2.667,2.667,0,0,1,2.667,2.667v8.711H33.772Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(30.733 8.956)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(37.083 8.956)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(43.322 8.956)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18159.441 373.93)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.774,418.4H80.752a5.31,5.31,0,0,0,5.306-5.31v-.025l.029-14.758a5.334,5.334,0,0,0-5.334-5.334H33.772a5.348,5.348,0,0,0-5.334,5.334v14.758A5.351,5.351,0,0,0,33.774,418.4Zm0-17.427a2.667,2.667,0,0,1,2.667-2.667H78.085a2.667,2.667,0,0,1,2.667,2.667v8.711H33.772Z",
    transform: "translate(-28.438 -392.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(30.733 8.956)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(37.083 8.956)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 2.052,
    cy: 2.052,
    rx: 2.052,
    ry: 2.052,
    transform: "translate(43.322 8.956)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18131.5 412.774)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 17.454,
    transform: "translate(0 4.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.48,0l4.48,7.884H0Z",
    transform: "translate(23.904) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 4.571,
    transform: "translate(12.882 4.3)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 154,
    height: 115,
    transform: "translate(466 668)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStep5);
export default __webpack_public_path__ + "static/media/img_step5.92d839dd3c9cbbeae2fb1877e1d7c048.svg";
export { ForwardRef as ReactComponent };